/**
 * Copyright © OXID eSales AG. All rights reserved.
 * See LICENSE file for license details.
 */

export function registerTreeView() {
    // Treeview
    let treeViewUrl = $('form.dd-treeview-form').attr('action'),
        $treeviewModal = $('.dd-treeview-modal'), $treeviewForm = $('.dd-treeview-form'),
        $treeviewMain = $('#dd-treeview-main-inner'), $treeviewSnippets = $('#dd-treeview-snippets-inner'),
        $treeviewMainSearch = $('.dd-treeview-search-main'),
        $treeviewSnippetsSearch = $('.dd-treeview-search-snippets'),
        $treeviewAjaxLoaderMain = $('.dd-treeview-main-loader'),
        $treeviewAjaxLoaderSnippets = $('.dd-treeview-snippets-loader'), treeviewMainSearchTO = false,
        treeviewSnippetsSearchTO = false;

    $treeviewModal.modal({
        backdrop: false,
        keyboard: false,
        show: false
    }).on('hidden.bs.modal', function () {
        $treeviewForm.trigger("reset");
        $treeviewMain.jstree(true).clear_search();
        $treeviewMain.jstree(true).close_all();
        $treeviewSnippets.jstree(true).clear_search();
        $treeviewSnippets.jstree(true).close_all();
        $('#btn_tab_treeview_main').tab('show');
        $treeviewAjaxLoaderMain.hide();
        $treeviewAjaxLoaderSnippets.hide();
    });

    $treeviewForm.on('submit', function (e) {
        e.preventDefault();
        let value = $('#elm_edit_treeview_contentid').val();
        $treeviewModal.modal('hide');
        let $picker = $('#elm_edit_cms');
        if ($picker.length && typeof $picker[0].selectize == 'object') {
            $picker[0].selectize.setValue(value);
        }
    });

    $('.dd-veditor-treeview-action').on('click', function () {
        if (!$(this).hasClass('disabled')) {
            $treeviewMain.jstree(true).refresh();
            $treeviewSnippets.jstree(true).refresh();
            $treeviewModal.modal('show');
        }
    });

    $('#btn_clear_treeview_search_main').on('click', function () {
        $treeviewMainSearch.val('');
        $treeviewMain.jstree(true).show_all();
        $treeviewMain.jstree(true).clear_search();
        $treeviewMain.jstree(true).close_all();
        $('#btn_clear_treeview_search_main').hide();
        $treeviewAjaxLoaderMain.hide();
    });

    $('#btn_clear_treeview_search_snippets').on('click', function () {
        $treeviewSnippetsSearch.val('');
        $treeviewSnippets.jstree(true).show_all();
        $treeviewSnippets.jstree(true).clear_search();
        $treeviewSnippets.jstree(true).close_all();
        $('#btn_clear_treeview_search_snippets').hide();
        $treeviewAjaxLoaderSnippets.hide();
    });

    $treeviewMainSearch.on('input', function () {
        if ($treeviewMainSearch.val() === '') {
            $('#btn_clear_treeview_search_main').hide();
            $treeviewMain.jstree(true).clear_search();
        } else {
            $('#btn_clear_treeview_search_main').show();
        }
    });

    $treeviewSnippetsSearch.on('input', function () {
        if ($treeviewSnippetsSearch.val() === '') {
            $('#btn_clear_treeview_search_snippets').hide();
            $treeviewSnippets.jstree(true).clear_search();
        } else {
            $('#btn_clear_treeview_search_snippets').show();
        }
    });

    $treeviewMain.on('move_node.jstree', function (e, data) {
        $.get(treeViewUrl + '&fnc=saveTreeviewNode&id=' + data.node.id + '&parentid=' + data.parent.replace('#', '') + '&pos=' + data.position + '&oldparentid=' + data.old_parent + '&oldpos=' + data.old_position);
    }).on('changed.jstree', function (e, data) {
        $('#elm_edit_treeview_contentid').val('' + data.instance.get_node(data.selected[0]).id);
    }).on('dnd_start.vakata.jstree', function () {
        $('#jstree-marker').appendTo('.dd-treeview-modal');
    }).on('search.jstree', function (nodes, str) {
        $treeviewAjaxLoaderMain.show();
        if (str.nodes.length === 0) {
            $treeviewMain.jstree(true).hide_all();
            $('.dd-treeview-main-no-results').show();
        }
        $treeviewAjaxLoaderMain.hide();
    }).on('clear_search.jstree', function () {
        $treeviewAjaxLoaderMain.hide();
    }).on('show_all.jstree', function () {
        $('.dd-treeview-main-no-results').hide();
    }).jstree({
        "core": {
            "animation": 250,
            "force_text": true,
            "check_callback": true,
            "themes": {"name": "default", "stripes": true, "dots": true, "responsive": true},
            'data': {
                'url': treeViewUrl + '&fnc=getTreeviewNodes&type=main', 'data': function (node) {
                    return {'id': node.id};
                }
            }
        },
        "dnd": {"copy": false, "inside_pos": "last", "large_drop_target": true},
        "search": {
            "show_only_matches": true,
            "show_only_matches_children": true,
            "ajax": {'url': treeViewUrl + '&fnc=searchTreeviewNodes&type=main'}
        },
        "plugins": ["dnd", "search"]
    });

    $treeviewSnippets.on('changed.jstree', function (e, data) {
        $('#elm_edit_treeview_contentid').val(data.instance.get_node(data.selected[0]).id);
    }).on('search.jstree', function (nodes, str) {
        $treeviewAjaxLoaderSnippets.show();
        if (str.nodes.length === 0) {
            $treeviewSnippets.jstree(true).hide_all();
            $('.dd-treeview-snippets-no-results').show();
        }
        $treeviewAjaxLoaderSnippets.hide();
    }).on('clear_search.jstree', function () {
        $treeviewAjaxLoaderSnippets.hide();
    }).on('show_all.jstree', function () {
        $('.dd-treeview-snippets-no-results').hide();
    }).jstree({
        "core": {
            "animation": 250,
            "check_callback": true,
            "force_text": true,
            "themes": {"name": "default", "stripes": true, "dots": true, "responsive": true},
            'data': {
                'url': treeViewUrl + '&fnc=getTreeviewNodes&type=snippets', 'data': function (node) {
                    return {'id': node.id};
                }
            }
        },
        "search": {
            "show_only_matches": true,
            "show_only_matches_children": true,
            "ajax": {'url': treeViewUrl + '&fnc=searchTreeviewNodes&type=snippets'}
        },
        "plugins": ["search"]
    });

    $treeviewMainSearch.keyup(function () {
        if (treeviewMainSearchTO) {
            clearTimeout(treeviewMainSearchTO);
        }
        treeviewMainSearchTO = setTimeout(function () {
            $treeviewMain.jstree(true).show_all();
            $treeviewAjaxLoaderMain.show();
            $treeviewMain.jstree(true).search($treeviewMainSearch.val());
        }, 250);
    });

    $treeviewSnippetsSearch.keyup(function () {
        if (treeviewSnippetsSearchTO) {
            clearTimeout(treeviewSnippetsSearchTO);
        }
        treeviewSnippetsSearchTO = setTimeout(function () {
            $treeviewSnippets.jstree(true).show_all();
            $treeviewAjaxLoaderSnippets.show();
            $treeviewSnippets.jstree(true).search($treeviewSnippetsSearch.val());
        }, 250);
    });
}
